/**
 * CSS 변수 --vh (모바일 뷰포트 높이)
 */
export class HomeViewport {
    static init(): void {
        const set = (): void => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        };
        window.addEventListener("load", set);
        window.addEventListener("resize", set);
        set();
    }
}
